<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Area"
      @click.native.stop
    >
      <v-select
        v-model="suiteAreaValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        placeholder="Select from list"
        multiple
        :options="suiteAreaOptions"
        :reduce="area => area._id"
      />
    </b-form-group>
    <b-form-group label="Status">
      <b-form-checkbox
        v-for="option in statusOptions"
        :key="option.code"
        v-model="statusValue"
        :value="option.code"
        name="flavour-3a"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <b-form-group
      label="Created At"
    >
      <b-input-group>
        <flat-pickr
          v-model="createdAtFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BInputGroup, BButton, BRow, BCol, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BInputGroup,
    BRow,
    BCol,
    BInputGroupAppend,
    BFormCheckbox,
    flatPickr,
    vSelect,
  },
  props: {
    status: {
      type: [Array, null],
      default: null,
    },
    suiteArea: {
      type: [Array, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    suiteAreaOptions: {
      type: Array,
      required: true,
    },
    createdAtFilter: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      createdAtFilterValue: this.createdAtFilter,
      statusValue: JSON.parse(JSON.stringify(this.status)) || [],
      suiteAreaValue: JSON.parse(JSON.stringify(this.suiteArea)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    status: {
      immediate: true,
      handler(val) {
        this.statusValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    suiteArea: {
      immediate: true,
      handler(val) {
        this.suiteAreaValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    createdAtFilter: {
      immediate: true,
      handler(val) {
        this.createdAtFilterValue = val
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.createdAtFilterValue) {
        this.$emit('emitShowFilter')
      }
    },
    applyFilter() {
      this.$emit('update:status', this.statusValue)
      this.$emit('update:suiteArea', this.suiteAreaValue)
      this.$emit('update:createdAt', this.createdAtFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.createdAtFilterValue = ''
      this.statusValue = []
      this.suiteAreaValue = []

      this.$emit('update:status', this.statusValue)
      this.$emit('update:createdAt', this.createdAtFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
